export default "__VITE_ASSET__BiIcwsfZ__"